import React from 'react';
import { Button, Modal } from "antd";



import './EachAccessKey.scss';


const EachAccessKey = (props) => {
    return (
        <div>
            <ul>
                <li>{props.accessKeyId}</li>
                <li>{props.date}</li>
                <li>{props.status}</li>
                <li>
                    <Button
                        icon="delete"
                        onClick={e =>
                            showDeleteConfirm(e, props.handleDeleteClick, props.id, props.accessKeyId)
                          }
                    />
                </li>
            </ul>
        </div>
    )
}


const showDeleteConfirm = (
    e,
    handleDeleteClick,
    apiId,
    accessKey
  ) => {
    e.stopPropagation()
    Modal.confirm({
      title: `Do you want to remove the ${accessKey} Access Key?`,
      content:
        "This will only remove your Api Key from CloudFlyer.",
      onOk() {
        handleDeleteClick(apiId)
      }
    })
  }
  

export default EachAccessKey;